import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export enum WorkNoteAction {
  CREATE_WORK_NOTE = "CREATE_WORK_NOTE",
}

export enum WorkNoteActionNotAvailableReason {
  UNSUPPORTED_PARTNER = "UNSUPPORTED_PARTNER",
  FEATURE_DISABLED = "FEATURE_DISABLED",
}

interface WorkNoteAvailableAction {
  action: WorkNoteAction;
  allowed: boolean;
  notAllowedReason: WorkNoteActionNotAvailableReason | null;
  notAllowedDebugMessage: string | null;
}

interface GetWorkNoteAvailableActionsResponse {
  availableActions: WorkNoteAvailableAction[];
}

export type WorkNoteAvailableActionsData = {
  [key in WorkNoteAction]?: WorkNoteAvailableAction;
};

export const useWorkNoteAvailableActions = (patientId: string) => {
  return useApi<
    GetWorkNoteAvailableActionsResponse,
    WorkNoteAvailableActionsData
  >({
    queryOptions: {
      enabled: Boolean(patientId),
      queryKey:
        QueryKeys.Patient.MedicalRecords.WorkNotes.AVAILABLE_ACTIONS(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get(
          "/clinic/work-notes/available-actions",
          { params: { patientId } },
        );
        return response?.data;
      },
      select: (data) => {
        return data.availableActions.reduce((acc, action) => {
          acc[action.action] = action;
          return acc;
        }, {} as WorkNoteAvailableActionsData);
      },
    },
  });
};
